import { Injectable } from '@angular/core';
import { Observable, of } from 'rxjs';
import { map, take } from 'rxjs/operators';
import { DialogService } from '@gelato-api-ui/sdk/src/lib/shared/dialog/dialog.service';
import { EProductVariantsUpdateSummary } from '@api-ui-app/src/app/e-commerce-stores/lib/e-product-variants-update-summary';
import { EProductWizardMode } from '@gelato-api-ui/core/e-commerce/e-product-wizard-mode.enum';
import { EProductVariantsCollection } from '@gelato-api-ui/core/e-commerce/types/e-product-variants-collection';
import { StoreProductVariantsUpdateModalComponent } from '@api-ui-app/src/app/e-commerce-stores/store-product-variants-update-modal/store-product-variants-update-modal.component';
import { SanityProduct } from '@gelato-api-ui/core/sanity/sanity-product';
import { SanityProductCategoryName } from '@gelato-api-ui/core/sanity/constants/sanity-categories/sanity-product-category-name.enum';
import { ECommerceProductVariantUpdateSummaryService } from '@api-ui-app/src/app/e-commerce-stores/services/e-commerce-product-variant-update-summary.service';

@Injectable({ providedIn: 'root' })
export class ECommerceProductVariantUpdateConfirmationService {
  constructor(
    private readonly dialogService: DialogService,
    private readonly productVariantUpdateSummaryService: ECommerceProductVariantUpdateSummaryService,
  ) {}

  confirm(
    mode: EProductWizardMode,
    originalStoreProductVariantsCollection: EProductVariantsCollection,
    sanityProductCategoryName: SanityProductCategoryName,
    sanityProduct: SanityProduct,
    storeProductVariantsCollection: EProductVariantsCollection,
  ): Observable<boolean> {
    const productVariantsUpdateSummary: EProductVariantsUpdateSummary = this.productVariantUpdateSummaryService.get(
      mode,
      storeProductVariantsCollection,
      originalStoreProductVariantsCollection,
      sanityProductCategoryName,
      sanityProduct,
    );

    if (this.mustShowModal(productVariantsUpdateSummary)) {
      return this.dialogService
        .open(StoreProductVariantsUpdateModalComponent, { data: { productVariantsUpdateSummary } })
        .afterClosed()
        .pipe(take(1), map(Boolean));
    }

    return of(true);
  }

  private mustShowModal(productVariantsUpdateSummary: EProductVariantsUpdateSummary): boolean {
    return productVariantsUpdateSummary?.added?.length > 0 || productVariantsUpdateSummary?.removed?.length > 0;
  }
}
